import VueCookies from 'vue-cookies'
import Vue from 'vue'
import App from '../components/App.vue'
import GlobalMixin from "./../app/mixins/GlobalMixin";
import makeStore from '../store/index';
import { createRouter } from '../app/router'
import { sync } from 'vuex-router-sync'
import extensions from './app/extensions';
import initFontAwesome from './app/fontAwesome'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

import "./../../scss/app.scss";

extensions()

const store = makeStore({});
const router = createRouter(store);

sync(store, router)

Vue.mixin(GlobalMixin);

Vue.use(VueCookies)

Vue.use(BootstrapVue)

Vue.component('apexchart', VueApexCharts)

initFontAwesome()

const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./resources/assets/js/_start/index.js